var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "leftBox cockpitBox" }, [
    _c("div", { staticClass: "cockpit_header" }, [
      _c("div", { staticClass: "cockpit_header_bg" }, [
        _c("div", [
          _c("img", {
            attrs: { src: require("@/assets/img/cockpit/deng.png"), alt: "" },
          }),
        ]),
        _c("div", { staticClass: "header_title" }, [_vm._v("待备案项目")]),
        _c("div", [
          _c("img", {
            attrs: { src: require("@/assets/img/cockpit/dian.png"), alt: "" },
          }),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "cockpit_content" }, [
      _c("div", { staticClass: "record_num" }, [
        _c("div", { staticClass: "record_num_box" }, [
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.projectData.nodeCount))]),
            _vm._v(" 个"),
          ]),
          _c("div", [_vm._v("待备案节点")]),
        ]),
        _c("div", { staticClass: "record_num_box" }, [
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.projectData.count))]),
            _vm._v(" 条"),
          ]),
          _c("div", [_vm._v("待备案条数")]),
        ]),
      ]),
      _c("div", { staticClass: "nodeDistribution cockpit_content_box" }, [
        _c("div", { staticClass: "cockpit_content_boxHeader" }, [
          _c("div", { staticClass: "header_cicle" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/cicle.png"),
                alt: "",
              },
            }),
          ]),
          _c("div", { staticClass: "header_decrit" }, [
            _vm._v("待备案节点分布"),
          ]),
          _c("div", { staticClass: "header_line" }),
          _c("div", { staticClass: "header_sanjiao" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/sanjiao.png"),
                alt: "",
              },
            }),
          ]),
        ]),
        _vm._m(0),
      ]),
      _c("div", { staticClass: "nodeDistribution cockpit_content_box" }, [
        _c("div", { staticClass: "cockpit_content_boxHeader" }, [
          _c("div", { staticClass: "header_cicle" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/cicle.png"),
                alt: "",
              },
            }),
          ]),
          _c("div", { staticClass: "header_decrit" }, [
            _vm._v("待备案部门分布"),
          ]),
          _c("div", { staticClass: "header_line" }),
          _c("div", { staticClass: "header_sanjiao" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/cockpit/sanjiao.png"),
                alt: "",
              },
            }),
          ]),
        ]),
        _vm._m(1),
      ]),
      _c(
        "div",
        { staticClass: "tableBox", staticStyle: { display: "none" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, stripe: "", height: "272" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "businessName",
                  label: "项目/标段名称",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: scope.row.businessName,
                              placement: "right",
                            },
                          },
                          [
                            _c("div", { staticClass: "businessName" }, [
                              _vm._v(
                                " " + _vm._s(scope.row.businessName) + " "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "flowName",
                  label: "业务节点",
                  align: "center",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "processinstancecreatedate",
                  sortable: "",
                  width: "100",
                  align: "center",
                  label: "提交时间",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "superviseDeptName",
                  width: "110",
                  label: "待处理部门",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "cockpit_content_boxContent distribution" },
      [_c("div", { attrs: { id: "echartsData" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "cockpit_content_boxContent distribution" },
      [_c("div", { attrs: { id: "echartsData1" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }